import { COLORS } from '@btime/constants'
import React from 'react'

import { PermissionChecker } from '../../session'
import { useLocalStorageWatcher } from '../../../utils/helpers/localStorage'
import AddNewButton from './AddNewButton'
import ControlBar from './ControlBar'
import FilterWrapper from './filters/FilterWrapper'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SideMenuTemplate from '../../../components/templates/v2/SideMenuTemplate'
import ConfigsLoader from '../../../containers/configs/_load/ConfigsLoader'
import ServiceOrderNotificationAlert from '../_common/ServiceOrderNotificationAlert'

const ServiceOrdersListPage = () => {
  useLocalStorageWatcher('SERVICE_ORDERS_LAST_SCREEN', 'list')

  return (
    <SideMenuTemplate bgColor={COLORS.white}>
      <ServiceOrderNotificationAlert>
        <Separator weight={6} flex={1}>
          <PermissionChecker permission="listServiceOrder">
            <ConfigsLoader>
              <FilterWrapper>
                <PageHeader />
                <ControlBar />
                <PageContent />
                <AddNewButton />
              </FilterWrapper>

              <Separator weight={32} />
            </ConfigsLoader>
          </PermissionChecker>
        </Separator>
      </ServiceOrderNotificationAlert>
    </SideMenuTemplate>
  )
}

export default ServiceOrdersListPage
